import React, { useState, useEffect } from 'react';

// keep track of whether the typeform embed script has been injected
let scriptInjected = false;
function ensureTypeformScript() {
  if (scriptInjected) return;
  const s = document.createElement('script');
  s.src = '//embed.typeform.com/next/embed.js';
  s.async = true;
  document.body.appendChild(s);
  scriptInjected = true;
}

/**
 * A button that opens the provided Typeform (live form) when clicked.
 *
 * It renders the `<div data-tf-live="..."/>` only when the form is visible
 * so that the embed script initializes at the right time.  Multiple buttons
 * can be used without reloading the script.
 *
 * Props:
 *   className - optional CSS class for the wrapping <button>
 *   children  - text/content shown inside the button (defaults to "Get Started")
 */
function TypeformButton({ className = '', children = 'Get Started' }) {
  const [open, setOpen] = useState(false);

  // ensure the embed script is loaded on first render so that the
  // <div data-tf-live> can be processed whether or not the overlay
  // is visible.
  useEffect(() => {
    ensureTypeformScript();
  }, []);

  const wrapperStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    background: 'rgba(0,0,0,0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  };

  const closeStyle = {
    position: 'absolute',
    top: '1rem',
    right: '1rem',
    background: 'transparent',
    border: 'none',
    color: '#fff',
    fontSize: '2rem',
    cursor: 'pointer',
  };

  return (
    <>
      <button
        className={className}
        onClick={() => setOpen(true)}
        type="button"
      >
        {children}
      </button>

      <div
        className="typeform-popup-wrapper"
        style={{ display: open ? 'flex' : 'none', ...wrapperStyle }}
      >
        {/* typeform will replace this div with the actual form */}
        <div data-tf-live="01KJ518ETAA9BPC70QE810D7AB"></div>
        <button
          className="typeform-close-btn"
          style={closeStyle}
          onClick={() => setOpen(false)}
        >
          ×
        </button>
      </div>
    </>
  );
}

export default TypeformButton;
